import React from "react";

export default function CancellationAndRefundPolicy() {
  return (
    <div className="w-full h-screen overflow-y-scroll">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="pt-8 pb-20">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
            Cancellation & Refund Policy
            </h1>
            <p className="text-gray-500 mb-8">
            <b>Last updated on: December 2025</b>
            </p>
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6 mb-6">
            <p className="text-lg text-gray-700 mb-4">
                <strong className="text-gray-900">LEVIT8 LABS PRIVATE LIMITED</strong>{" "}
                (a private limited company) is committed to providing excellent AI Research for Fashion,
                AI-powered fashion services and maintaining transparent policies
                regarding cancellations and refunds.
            </p>
            <p className="text-gray-700">
                This Cancellation & Refund Policy applies to all services provided
                under the <strong className="text-gray-900">TryOn AI</strong> and{" "}
                <strong className="text-gray-900">TryOn Labs</strong> brands, which
                are owned and operated by LEVIT8 LABS PRIVATE LIMITED. This policy
                covers our virtual try-on, model swap, cataloging, model generation,
                garment generation, and image editing and enhancement services.
            </p>
            </div>

            <div className="space-y-6">
            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Service Cancellation
                </h2>
                <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm leading-relaxed">
                <li>
                    Cancellation requests for services must be submitted in writing to
                    our team at{" "}
                    <a
                    href="mailto:contact@tryonlabs.ai"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                    contact@tryonlabs.ai
                    </a>
                    &nbsp;or&nbsp; 
                    <a
                    href="mailto:admin@levit8labs.in"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                    admin@levit8labs.in
                    </a>
                    .
                </li>
                <li>
                    Cancellations requested before the initiation of service processing
                    may be eligible for a full or partial refund, subject to the
                    terms of the specific service package.
                </li>
                <li>
                    Once service processing has commenced (e.g., images uploaded,
                    processing started), cancellations will be evaluated on a
                    case-by-case basis, considering work completed, credits consumed,
                    and resources allocated.
                </li>
                <li>
                    Custom service packages and bulk orders are subject to the terms
                    specified in individual service agreements or contracts.
                </li>
                <li>
                    For subscription-based services, cancellations will take effect at
                    the end of the current billing period, and no refunds will be
                    provided for the remaining period unless otherwise specified.
                </li>
                </ul>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Refund Policy
                </h2>
                <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm leading-relaxed">
                <li>
                    Refunds for services will be processed based on the specific terms
                    outlined in the service package or subscription plan.
                </li>
                <li>
                    If a refund is approved, it will be processed within 15-30 business
                    days from the date of approval, subject to banking procedures.
                </li>
                <li>
                    Refunds will be issued using the same payment method used for the
                    original transaction, unless otherwise specified.
                </li>
                <li>
                    Partial refunds may apply for services where processing has been
                    partially completed, based on credits consumed and deliverables
                    generated.
                </li>
                <li>
                    Credit-based refunds: If you have unused credits in your account,
                    refunds may be issued as account credits rather than monetary
                    refunds, depending on the circumstances and our discretion.
                </li>
                </ul>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Non-Refundable Services
                </h2>
                <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm leading-relaxed">
                <li>
                    Completed and delivered services, including generated images,
                    videos, or visual content that has been processed and made
                    available for download
                </li>
                <li>
                    Services explicitly marked as non-refundable in the service package
                    or subscription plan
                </li>
                <li>
                    Credits that have been consumed or used for service processing
                </li>
                <li>
                    Subscription fees for periods that have already elapsed
                </li>
                <li>
                    Custom development work or specialized services that have been
                    delivered and accepted
                </li>
                </ul>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Service-Specific Policies
                </h2>
                <ul className="list-disc ml-6 space-y-2 text-gray-700 text-sm leading-relaxed">
                <li>
                    <strong>Virtual Try-On:</strong> Once images are processed and
                    results are generated, the service is considered complete and
                    non-refundable.
                </li>
                <li>
                    <strong>Model Generation & Swap:</strong> Cancellations are only
                    possible before model generation begins. Once a model is generated,
                    the service is non-refundable.
                </li>
                <li>
                    <strong>Cataloging Services:</strong> Bulk cataloging orders may be
                    partially refundable based on the number of items processed versus
                    the total order.
                </li>
                <li>
                    <strong>Image Editing & Enhancement:</strong> Services are
                    non-refundable once the edited images are delivered and made
                    available for download.
                </li>
                </ul>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Dispute Resolution
                </h2>
                <p className="text-gray-700 text-sm leading-relaxed">
                If you have concerns regarding our services or wish to dispute a
                charge, please contact us at{" "}
                <a
                    href="mailto:contact@tryonlabs.ai"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                >
                    contact@tryonlabs.ai
                </a>
                &nbsp;or&nbsp; 
                <a
                    href="mailto:admin@levit8labs.in"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                    admin@levit8labs.in
                    </a>
                . We will review your concern and work with you to reach a
                resolution. We aim to respond to all disputes within 5-7 business
                days.
                </p>
            </div>

            <div className="bg-white rounded-lg border border-gray-200 shadow-md p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">
                Contact Us
                </h2>
                <div className="space-y-2 text-sm text-gray-700">
                <p>
                    <strong className="text-gray-900">Email:</strong>{" "}
                    <a
                    href="mailto:contact@tryonlabs.ai"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                    contact@tryonlabs.ai
                    </a>
                    ,&nbsp; 
                    <a
                    href="mailto:admin@levit8labs.in"
                    className="text-primary-600 hover:text-primary-700 transition-colors"
                    >
                    admin@levit8labs.in
                    </a>
                </p>
                <p className="mt-3">
                    <strong className="text-gray-900">Address:</strong>
                    <br />
                    LEVIT8 LABS PRIVATE LIMITED
                    <br />
                    Aspire Coworks - Balaji Arcade
                    <br />
                    No. 472/7, Balaji Arcade, AVS Compound,
                    <br />
                    20th L Cross Road, AVS Layout, Ejipura,
                    <br />
                    Koramangala, Bengaluru, Karnataka
                    <br />
                    PIN: 560095
                </p>
                </div>
            </div>

            <p className="text-gray-500 text-sm">
                <strong>Note:</strong> This policy is issued by LEVIT8 LABS PRIVATE
                LIMITED and applies to all services provided under the TryOn AI and
                TryOn Labs brands. This policy is subject to change without prior
                notice. Please review this page periodically for updates. For specific
                service packages or subscription plans, the terms outlined in those
                agreements will take precedence over this general policy.
            </p>
            </div>
        </div>
        </div>
    </div>
  );
}
